export const authenticationSelector = (state) => state.get('authentication');

export const userInfoSelector = (state) => state.get('authentication').get('userInfo');

export const inAuthenticatedSectionSelector = (state) => state.get('authentication').get('inAuthenticatedSection') && state.get('ui').get('urlState').name !== 'kickstart';
